export enum RequestErrorType {
  Generic = 'G001',
  ParseIssue = 'G002',
  Unauthorized = 'G003',
}
